import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";

import MUIDataTable from "mui-datatables";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";


// data
import {BankTransactionList} from "./bankTransactionsList-api"
//auth
import auth from "../../../auth/auth-helper";

const columns = [
  {
    name: "account_no",
    label: "Account No",
  },
  {
    name: "amount",
    label: "Amount",
  },
  {
    name: "date_time",
    label: "Date",
  },

  {
    name: "detail",
    label: "PS",
  },
  {
    name: "transaction_id",
    label: "ID",
  },
  {
    name: "teller",
    label: "Teller",
  },
  {
    name: "withdraw",
    label: "Withraw",
  },
];

export default function Transactions() {
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    BankTransactionList(signal,credentials).then((res) => {
      if (res.status === 200) {
        console.log('token here .....................'+ credentials);
        // console.log(res.status);
        console.log(res);
        //console.log(res.statusCode);
        setTransactions(res.response[0]);
        
      } else {
        console.log(res.error);
      }
     
    });

    return function cleanup() {
      abortController.abort();
    };
  }, []);
  return (
    <>
      <PageTitle title="Bank Transactions" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title="Transactions List"
            data={transactions}
            columns={columns}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Widget title="Material-UI Table" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
            <Table data={mock.table} />
          </Widget>
        </Grid> */}
      </Grid>
    </>
  );
}